/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc
 */
import * as References from './BuyerBillingDataRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import { restClient } from 'billing-portal-ui/js/clients/chirpClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: restClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getPaymentMethods
 */
export const GET_PAYMENT_METHODS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getPaymentMethods';
export const GET_PAYMENT_METHODS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PAYMENT_METHODS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getPaymentMethodsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getSubscriptions
 */
export const GET_SUBSCRIPTIONS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getSubscriptions';
export const GET_SUBSCRIPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUBSCRIPTIONS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getInactiveSubscriptions
 */
export const GET_INACTIVE_SUBSCRIPTIONS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getInactiveSubscriptions';
export const GET_INACTIVE_SUBSCRIPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INACTIVE_SUBSCRIPTIONS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getInactiveSubscriptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getInvoices
 */
export const GET_INVOICES_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getInvoices';
export const GET_INVOICES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INVOICES_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset', 'sortProperty', 'sortDirection', 'filterStatuses', 'invoiceDateAfter', 'invoiceDateBefore', 'filterCollectionType', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getInvoicesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getCommercePayments
 */
export const GET_COMMERCE_PAYMENTS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getCommercePayments';
export const GET_COMMERCE_PAYMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_COMMERCE_PAYMENTS_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset', 'sortProperty', 'sortDirection', 'status', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.getCommercePaymentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getFailedCommercePayments
 */
export const GET_FAILED_COMMERCE_PAYMENTS_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getFailedCommercePayments';
export const GET_FAILED_COMMERCE_PAYMENTS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_FAILED_COMMERCE_PAYMENTS_QUERY_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient6;
    return ((_ctx$customClient6 = ctx.customClient) !== null && _ctx$customClient6 !== void 0 ? _ctx$customClient6 : chirpClient).call(References.getFailedCommercePaymentsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getQuotes
 */
export const GET_QUOTES_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getQuotes';
export const GET_QUOTES_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_QUOTES_QUERY_FIELD_NAME,
  args: ['pageLength', 'offset', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient7;
    return ((_ctx$customClient7 = ctx.customClient) !== null && _ctx$customClient7 !== void 0 ? _ctx$customClient7 : chirpClient).call(References.getQuotesRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getSubscription
 */
export const GET_SUBSCRIPTION_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getSubscription';
export const GET_SUBSCRIPTION_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SUBSCRIPTION_QUERY_FIELD_NAME,
  args: ['crmId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient8;
    return ((_ctx$customClient8 = ctx.customClient) !== null && _ctx$customClient8 !== void 0 ? _ctx$customClient8 : chirpClient).call(References.getSubscriptionRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.BuyerBillingDataRpc#getInvoice
 */
export const GET_INVOICE_QUERY_FIELD_NAME = 'com_hubspot_commerce_buyer_portal_rpc_BuyerBillingDataRpc_getInvoice';
export const GET_INVOICE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_INVOICE_QUERY_FIELD_NAME,
  args: ['crmId', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient9;
    return ((_ctx$customClient9 = ctx.customClient) !== null && _ctx$customClient9 !== void 0 ? _ctx$customClient9 : chirpClient).call(References.getInvoiceRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});